export default function() {

  // DOM.
  const siteHeader = document.querySelector('[data-js-site-header]');
  const toggle = document.querySelector('[data-js-nav-toggle]'); 
  const primaryNav = siteHeader.querySelector('.primary-nav');

  // Props.
  let primaryNavOpen = false;
  
  const openNav = () => {
    document.body.classList.add('primary-nav-open');
    toggle.innerHTML = "Close";
    primaryNavOpen = true;
  }
  
  const closeNav = () => {
    document.body.classList.remove('primary-nav-open');
    toggle.innerHTML = "Menu";
    primaryNavOpen = false;
  }

  // Toggle the primaryNav.
  const toggleNav = () => {
    if (!primaryNavOpen) {
      openNav();
    } else {
      closeNav();
    }
  }

  // Event listeners.
  if (toggle) {
    toggle.addEventListener('click', toggleNav);
  }
  
  document.querySelector('.site-header__logo a').addEventListener('click', closeNav);

  /**
   * 
   *  Remove menu state if resizing to desktop.
   * 
   */
  let desktopQuery = window.matchMedia('(min-width: 1024px)');
  desktopQuery.addEventListener("change", (e) => {
    if (e.matches) {
      // console.log('Switching to desktop!');
      document.documentElement.classList.remove('show-primary-nav');
    } else {
      // console.log('Switching to mobile');
      if (primaryNavOpen) {
        closeNav();
      }
    }
  });


  /**
   * Scroll Pixel.
   */
  // const scrollPixel = document.querySelector(`.scroll-pixel`);
  // const scrollPixelObserver = new IntersectionObserver((entries) => {
  //   (!entries[0].isIntersecting) ? 
  //     document.documentElement.classList.add(`is-scrolled`) : 
  //     document.documentElement.classList.remove(`is-scrolled`);
  // }, {
  //   threshold: 1
  // });
  // scrollPixelObserver.observe(scrollPixel);  
}